export { default } from './WidgetPerformance';
